const NOTES = {
  noel: { type: "sine", seq: [1568, 2093], gap: 0.07, dur: 0.35 },
  halloween: { type: "triangle", seq: [330, 247], gap: 0.12, dur: 0.45, glide: true },
  paques: { type: "sine", seq: [1047, 1319, 1568], gap: 0.05, dur: 0.25 },
  valentin: { type: "sine", seq: [880, 1109], gap: 0.1, dur: 0.4 },
  fetenat: { type: "triangle", seq: [784, 1047, 1319], gap: 0.06, dur: 0.25 },
  nouvelan: { type: "sine", seq: [1319, 1760, 2637], gap: 0.05, dur: 0.3 },
  blackfriday: { type: "square", seq: [988, 1319], gap: 0.06, dur: 0.12 },
  stpatrick: { type: "triangle", seq: [1175, 1480, 1760], gap: 0.06, dur: 0.22 },
  canada: { type: "triangle", seq: [784, 988, 1175], gap: 0.06, dur: 0.25 },
};
const KEY = "cx_hol_sound";
let ctx = null;

export const soundOn = () => localStorage.getItem(KEY) !== "0";
export const setSoundOn = (v) => localStorage.setItem(KEY, v ? "1" : "0");

export const playHoliday = (id) => {
  const n = NOTES[id];
  if (!n || !soundOn()) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const t0 = ctx.currentTime;
    n.seq.forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      const t = t0 + i * n.gap;
      o.type = n.type;
      o.frequency.setValueAtTime(f, t);
      if (n.glide) o.frequency.exponentialRampToValueAtTime(f * 0.75, t + n.dur);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(n.type === "square" ? 0.015 : 0.045, t + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, t + n.dur);
      o.connect(g).connect(ctx.destination);
      o.start(t);
      o.stop(t + n.dur + 0.02);
    });
  } catch (e) { /* audio unavailable */ }
};
